import React from 'react';
import InputSection from './InputSection';
import OutputSection from './OutputSection';

const Home = ({
    message,
    setMessage,
    selectedTone,
    setSelectedTone,
    onRewrite,
    rewrittenMessage,
    onCopy,
    copySuccess,
    isProcessing
}) => {
    return (
        <>
            {/* Hero Section */}
            <div className="mb-4 sm:mb-6 lg:mb-8">
                <div className="rounded-xl p-6 sm:p-8 bg-primary-600 dark:bg-primary-700 text-white shadow-primary">
                    <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
                        <div>
                            <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">
                                RewriteKing
                            </h2>
                            <p className="text-white/90 dark:text-white/80 mt-1">
                                Transform casual messages into professional communication in seconds.
                            </p>
                        </div>
                        <div className="flex items-center gap-3">
                            <span className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-primary-500 dark:bg-primary-600 text-white text-sm font-medium shadow">
                                <i className="fas fa-crown"></i>
                                Premium quality rewrites
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Editor Grid */}
            <div className="flex-1 grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 min-h-0">
                <InputSection
                    message={message}
                    setMessage={setMessage}
                    selectedTone={selectedTone}
                    setSelectedTone={setSelectedTone}
                    onRewrite={onRewrite}
                    isProcessing={isProcessing}
                />

                <OutputSection
                    rewrittenMessage={rewrittenMessage}
                    onCopy={onCopy}
                    copySuccess={copySuccess}
                    isProcessing={isProcessing}
                />
            </div>
        </>
    );
};

export default Home;

